import React, { useState, useReducer, useEffect, useRef } from 'react';
import { isEmpty, range } from 'lodash';
import { put, remove } from '../common/http';
import PopupBase from './PopupBase';
    
const getTitle = ({ isOnlyApprove, isOnlyDelete, isOnlyExtend, isOnlyUpdate }) => {
    if (isOnlyApprove) return '승인하기';
    if (isOnlyDelete) return '삭제하기';
    if (isOnlyExtend) return '연장하기';
    if (isOnlyUpdate) return '수정하기';
}

const getDefaultUnit = list => {
    const isOnlySaveType = list.filter(item => item.TYPE === '001').length === list.length;
    return isOnlySaveType ? 5 : 30;
}

const getWorkDaysOption = day => {
    return range(1, day === 5 ? 41 : 11)
        .map(n => ({ key: `${day}_${n * day}`, text: n * day, value: n * day }));
}

const getKeywordList = (keywords = [], startIndex = 0) => {
    if (keywords === null || keywords === '') return [''];
    let curKeywords = [];
    if (typeof keywords === 'string') curKeywords = keywords.split(',');
    else curKeywords = keywords;
    if (curKeywords.length === 0) return [''];
    if (startIndex === 0 || curKeywords.length <= 1) return curKeywords;
    return curKeywords.slice(startIndex);
}

const SlotEditPop = props => {

    const {
        isOpen,
        save,
        close,
        data: {
            editTargets = [{}],
            isOnlyExtend = false,
            isOnlyApprove = false,
            isOnlyUpdate = false,
            isOnlyDelete = false
        }
    } = props;
    const editTarget = editTargets.length === 1 ? editTargets[0] : {};
    const [values, setValues] = useState({});
    const [innerRankKeywords, setInnerRankKeywords] = useState(getKeywordList(editTarget.INNER_RANK_KEYWORDS));
    const keywordInputRefs = useRef([]);
    
    const handleValChange = e => {
        setValues({
            ...values,
            [e.target.name]: e.target.value,
        })
    }

    const handleDayChange = (e, data) => {
        setValues({ ...values, days: data.value });
    }

    const handleEditSave = async () => {
        if (isEmpty(values) && innerRankKeywords.filter(k => k.trim()).length === 0) return alert('입력된 정보가 없습니다.');
        
        const saveData = {
            ...values,
            INNER_RANK_KEYWORDS: innerRankKeywords.filter(k => k.trim()).join(','),
            ids: editTargets.map(t => t.ID)
        };
        
        const rslt = await put('/api/slots', saveData);
        if (rslt.code === 'success') {
            save(saveData);
        } else {
            alert('수정에 실패했습니다.')
        }
    }

    const handleDelete = async () => {
        const rslt = await remove(`/api/slots?${editTargets.map(t => t.ID).map(id => `ids=${id}`).join('&')}`);
        if (rslt.code === 'success') {
            save();
        } else {
            alert('삭제에 실패했습니다.')
        }
    }

    const handleAddKeyword = () => {
        setInnerRankKeywords([...innerRankKeywords, '']);
        // 새로 추가된 입력 필드에 포커스
        setTimeout(() => {
            const newIndex = innerRankKeywords.length;
            if (keywordInputRefs.current[newIndex]) {
                keywordInputRefs.current[newIndex].focus();
            }
        }, 0);
    }

    const handleRemoveKeyword = index => {
        setInnerRankKeywords(innerRankKeywords.filter((_, i) => i !== index));
    }

    const handleInnerRankKeywordChange = (e, index) => {
        setInnerRankKeywords(innerRankKeywords.map((keyword, i) => i === index ? e.target.value : keyword));
    }

    const handleInnerRankKeywordKeyDown = (e, index) => {
        if (e.key === 'Enter') {
            handleAddKeyword();
        }
    }

    useEffect(() => {
        if (isOnlyApprove) {
            setValues({ approveYn: 'Y' });
        }
    }, []);

    useEffect(() => {
        if (isOpen && isOnlyApprove) setValues({ approveYn: 'Y' });
        else setValues({});
    }, [isOpen]);

    return (
        <PopupBase title="슬롯 수정" confirmText="수정" cancelText="취소" confirm={handleEditSave} close={close}>
            <div className="modal-body">
                <div className="form-field">
                    <label className="field-lable">1000등 키워드</label>
                    <div className="field-input">
                        <span className="field-required">*</span>
                        <input 
                            type="text" 
                            name="MAIN_KEYWORD" 
                            value={values.MAIN_KEYWORD || editTarget.MAIN_KEYWORD || ''}
                            placeholder="1000등 키워드를 입력해주세요." 
                            onChange={handleValChange}
                        />
                    </div>      
                </div>
                <div className="form-field">
                    <label className="field-lable">상품명</label>
                    <div className="field-input">
                        <span className="field-required">*</span>
                        <input 
                            type="text" 
                            name="PLACE_NAME" 
                            value={values.PLACE_NAME || editTarget.PLACE_NAME || ''}
                            placeholder="상품명을 입력해주세요." 
                            onChange={handleValChange}
                        />
                    </div>      
                </div>
                <div className="form-field">
                    <label className="field-lable">상품 URL</label>
                    <div className="field-input">
                        <span className="field-required">*</span>
                        <input 
                            type="text" 
                            name="PLACE_URL" 
                            value={values.PLACE_URL || editTarget.PLACE_URL || ''}
                            placeholder="상품 URL을 입력해주세요." 
                            onChange={handleValChange}
                        />
                    </div>      
                </div>
                {/* <div className="form-field">
                    <label className="field-lable">아이템 ID</label>
                    <div className="field-input">
                        <span className="field-required">*</span>
                        <input 
                            type="text" 
                            name="PLACE_COMPARE_URL" 
                            value={values.PLACE_COMPARE_URL || editTarget.PLACE_COMPARE_URL || ''}
                            placeholder="가격비교 URL을 입력해주세요." 
                            onChange={handleValChange}
                        />
                    </div>      
                </div> */}
                {/* <div className="form-field">
                    <label className="field-lable">벤더아이템 ID</label>
                    <div className="field-input">
                        <span className="field-required">*</span>
                        <input 
                            type="text" 
                            name="PLACE_CODE" 
                            value={values.PLACE_CODE || editTarget.PLACE_CODE || ''}
                            placeholder="단품 MID를 입력해주세요." 
                            onChange={handleValChange}
                        />
                    </div>      
                </div> */}
                {/* <div className="form-field">
                    <label className="field-lable">400위 이내 키워드</label>
                    <div className="field-input">
                        <span className="field-required">*</span>
                        <input 
                            type="text" 
                            value={innerRankKeywords[0] || ''}
                            placeholder="[필수입력] 400위 이내 키워드를 입력해주세요."
                            onKeyDown={e => handleInnerRankKeywordKeyDown(e, 0)}
                            onChange={e => handleInnerRankKeywordChange(e, 0)}
                            ref={el => keywordInputRefs.current[0] = el}
                        />
                    </div>
                        {innerRankKeywords.slice(1).map((keyword, index) => (
                            <div className="field-input" key={`keyword-${index + 1}`}>
                                <button 
                                    type="button" 
                                    className="field-remove" 
                                    onClick={() => handleRemoveKeyword(index + 1)}>
                                        <i className="icon icon-trash"></i>
                                </button>
                                                             <input 
                                 type="text" 
                                 placeholder="[선택입력] 400위 이내 키워드를 입력해주세요." 
                                 value={keyword} 
                                 onKeyDown={e => handleInnerRankKeywordKeyDown(e, index + 1)}
                                 onChange={e => handleInnerRankKeywordChange(e, index + 1)}
                                 ref={el => keywordInputRefs.current[index + 1] = el}
                             />
                            </div>
                        ))}
                    <button type="button" className="btn" onClick={handleAddKeyword}>키워드 추가하기</button>
                </div> */}
                <div className="form-field">
                    <label className="field-lable">메모</label>
                    <div className="field-input">
                        <textarea 
                            name="MEMO" 
                            value={values.MEMO || editTarget.MEMO || ''}
                            placeholder="메모를 입력해주세요." 
                            onChange={handleValChange}
                            rows="3"
                        />
                    </div>      
                </div>
            </div>
        </PopupBase>
    )
};

export default SlotEditPop;